import { useMemo } from "react";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import { storefrontThemeForTenant } from "lib/storefrontTheme";
import useStorefrontCopy from "hooks/useStorefrontCopy";
import { mergePortalAccent } from "./portalTheme";

export default function usePortalTheme() {
  const { tenant } = useStorefrontTenant();
  const { locale } = useStorefrontCopy();
  const storefront = storefrontThemeForTenant(tenant, locale);
  return useMemo(
    () => mergePortalAccent(null, storefront.accent),
    [storefront.accent],
  );
}
